import { render, staticRenderFns } from "./addDeposit.vue?vue&type=template&id=18b9e26d&scoped=true&"
import script from "./addDeposit.vue?vue&type=script&lang=js&"
export * from "./addDeposit.vue?vue&type=script&lang=js&"
import style0 from "./addDeposit.vue?vue&type=style&index=0&id=18b9e26d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9e26d",
  null
  
)

export default component.exports